import { useEffect } from "react";

export const HideDevTools: React.FC = () => {
  useEffect(() => {
    // Hide DevTools in production if needed
    if (process.env.NODE_ENV === "production") {
      // Hide any console messages in production as needed
      const noop = () => {};
      // console.log = noop;
      // console.warn = noop;
      // console.error = noop;
    }
  }, []);

  return null;
};